import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import type { Coordinates, RGB } from '@modules/paint-picker-new/type';

export const PaintPickerShellStyle: StyleRule<{
    isPicking: boolean;
}> = ({ theme, isPicking }) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.foreground,
    right: 0,
    bottom: 0,
    cursor: isPicking ? 'none' : 'default',
});

export const PaintPickerShellContainer: StyleRule = () => ({
    overflow: 'hidden',
    height: '100%',
});

export const PickerCursor: StyleRule<{
    isPicking: boolean;
    cursorCoordinates: Coordinates;
    cursorVisible: boolean;
    currentColor: RGB | null;
}> = ({ isPicking, cursorCoordinates, cursorVisible, currentColor }) => ({
    opacity: isPicking && cursorVisible ? 1 : 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: `translate(calc(${cursorCoordinates.x}px - ${pxToRem(45)}), calc(${cursorCoordinates.y}px - ${pxToRem(45)}))`,
    position: 'relative',
    width: pxToRem(90),
    height: pxToRem(90),
    borderWidth: pxToRem(8),
    borderStyle: 'solid',
    borderRadius: '50%',
    borderColor: currentColor
        ? `rgb(${currentColor.r}, ${currentColor.g}, ${currentColor.b})`
        : '#fff',
});

export const PickerCursorIcon: StyleRule = () => ({
    color: '#fff',
    width: pxToRem(14),
    height: pxToRem(14),
});

export const PaintPickerMobileShellStyle: StyleRule = ({ theme }) => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: theme.siteVariables.zIndexes.foreground,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
});

export const CanvasStyling: StyleRule = () => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    visibility: 'hidden',
});
